module.exports = __webpack_public_path__ + "img/dashboard-fundo.8e25011f.svg";